import React from 'react';
import {Badge, BadgeProps} from './Badge';

export const Upcycled: React.FC<BadgeProps> = badgeProps => {
  return <Badge {...badgeProps} emoji={'♻️'} />;
};
